import React from 'react';
import QuantityControl from './QuantityControl';

const TrashIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 30 30" fill="none">
    <path d="M3.75 7.5H26.25" stroke="#FF0000" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M23.75 7.5V25C23.75 26.25 22.5 27.5 21.25 27.5H8.75C7.5 27.5 6.25 26.25 6.25 25V7.5" stroke="#FF0000" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10 7.5V5C10 3.75 11.25 2.5 12.5 2.5H17.5C18.75 2.5 20 3.75 20 5V7.5" stroke="#FF0000" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12.5 13.75V21.25" stroke="#FF0000" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M17.5 13.75V21.25" stroke="#FF0000" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const CartItem = ({ item, onIncrease, onDecrease, onRemove }) => {
  return (
    <div className="flex items-start gap-3 py-4 border-b border-gray-100 last:border-b-0">
      <div className="w-[56px] h-[56px] rounded-lg overflow-hidden shrink-0 bg-[#f0e6d6] flex items-center justify-center">
        <img
          src={item.image}
          alt={item.name}
          className="w-full h-full object-cover"
        />
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-2">
          <div className="min-w-0">
            <h4 className="m-0 text-[14px] font-semibold text-gray-800 leading-snug">
              {item.name}
            </h4>
            <p className="m-0 text-[12px] text-gray-400 mt-0.5">{item.size}{item.unitCost > 0 ? ` · NRs. ${Number(item.unitCost).toFixed(2)} per unit` : ''}</p>
            {item.sku && <p className="m-0 text-[11px] text-gray-400 mt-0.5">SKU: {item.sku}</p>}
          </div>
          <button
            type="button"
            aria-label={`Remove ${item.name}`}
            onClick={onRemove}
            className="flex items-center justify-center w-7 h-7 rounded-md border-none bg-transparent cursor-pointer shrink-0 hover:bg-red-50"
          >
            <TrashIcon />
          </button>
        </div>

        <div className="flex items-center justify-between gap-2 mt-2">
          <div className="flex items-center gap-3">
            <QuantityControl quantity={item.quantity} onIncrease={onIncrease} onDecrease={onDecrease} />
            <p className="m-0 text-[12px] text-gray-400">
              {item.quantity} * {item.unitsPerPack?.toLocaleString()} = {item.unitsPerPack * item.quantity} units
            </p>
          </div>
          <span className="text-[14px] font-bold text-brand-blue whitespace-nowrap">
            NRs. {Number(item.price || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </span>
        </div>
        {Number(item.shippingCost) > 0 && <p className="m-0 mt-1 text-right text-[11px] text-gray-400">Shipping: NRs. {Number(item.shippingCost).toFixed(2)} per batch</p>}
      </div>
    </div>
  );
};

export default CartItem;
